<p-dataView
  #dv
  layout="list"
  [paginator]="false"
  *ngIf="lendPeak && lendPeak.amortizationVersionManager"
>
  <!-- "list" template for DataView v19+ -->
  <ng-template #list let-items>
    <!-- Container (example using Tailwind classes, you can remove them if not needed) -->
    <div class="grid grid-cols-12 gap-4 grid-nogutter">
      <!-- We iterate over 'items' (the chunk of data given to us by DataView) -->
      <div
        class="col-span-12 w-full"
        *ngFor="
          let version of lendPeak.amortizationVersionManager.versions.reverse();
          let last = last
        "
      >
        <div class="p-6 flex flex-col gap-4">
          <!-- Basic Info (Version ID, timestamp, commit message, rollback button) -->
          <div style="width: 400px">
            <p-card>
              <h3>Version {{ version.versionId }}</h3>
              <span class="text-lg text-300">{{
                version.timestamp | date: "long"
              }}</span>
            </p-card>
            <p-divider></p-divider>
            <p-card *ngIf="version.commitMessage">
              <markdown [data]="version.commitMessage"></markdown>
            </p-card>
            <span *ngIf="!version.isRollback">
              <p-button
                label="Rollback"
                (click)="rollbackVersion(version.versionId, $event)"
              ></p-button>
            </span>
          </div>

          <!-- Accordion for Changes -->
          <p-accordion class="w-full">
            <!-- Input Changes -->
            <p-accordion-panel value="0">
              <p-accordion-header>Input Changes</p-accordion-header>
              <p-accordion-content>
                <div *ngIf="isEmpty(version.inputChanges)">
                  <em>No input changes in this version.</em>
                </div>
                <ng-container *ngIf="!isEmpty(version.inputChanges)">
                  <table class="changes-table">
                    <thead>
                      <tr>
                        <th>Field</th>
                        <th>Old</th>
                        <th>New</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let key of objectKeys(version.inputChanges)">
                        <td>{{ key }}</td>
                        <td>
                          <app-value-renderer
                            [value]="version.inputChanges[key].oldValue"
                          ></app-value-renderer>
                        </td>
                        <td>
                          <app-value-renderer
                            [value]="version.inputChanges[key].newValue"
                          ></app-value-renderer>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </p-accordion-content>
            </p-accordion-panel>

            <!-- Output Changes -->
            <p-accordion-panel value="1">
              <p-accordion-header>Output Changes</p-accordion-header>
              <p-accordion-content>
                <div *ngIf="isEmpty(version.outputChanges)">
                  <em>No output changes in this version.</em>
                </div>
                <ng-container *ngIf="!isEmpty(version.outputChanges)">
                  <p>Output changes detail...</p>
                  <!-- Or insert a table for output changes similar to input changes -->
                </ng-container>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
        <hr *ngIf="!last" class="my-2" />
      </div>
      <!-- end *ngFor over items -->
    </div>
  </ng-template>
</p-dataView>
